import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class RemoteConfigService {
  private _k1: string = null;
  private _k2: string = null;
  private _r1: string = null;
  private _ready: Promise<void> = null;

  constructor(private http: HttpClient) {}

  preload(): Promise<void> {
    if (this._ready) {
      return this._ready;
    }

    this._ready = new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + localStorage.getItem('token_user')
        })
      };
      this.http
        .get(environment.apiBaseUrl + "api/config_sync", httpOptions)
        .subscribe(
          (data: any) => {
            this._k1 = data.param_1;
            this._k2 = data.param_2;
            this._r1 = data.param_3;
            resolve();
          },
          (error) => reject(error)
        );
    });

    return this._ready;
  }

  get k1(): string {
    return this._k1;
  }

  get k2(): string {
    return this._k2;
  }

  get r1(): string {
    return this._r1;
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/services/remote-config.service.ts